import { render, staticRenderFns } from "./DropdownWithBody.vue?vue&type=template&id=71318f2c&"
import script from "./DropdownWithBody.vue?vue&type=script&lang=js&"
export * from "./DropdownWithBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports